module.exports = "/_next/static/images/og-image-diputi-min-773c155a721ea5b1158cb31461657705.jpg";